import { render, staticRenderFns } from "./ReferralTransactionHistory.vue?vue&type=template&id=93d7c75c&"
import script from "./ReferralTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./ReferralTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports